/** @jsx jsx */
import { jsx } from 'theme-ui';
import { FunctionComponent, forwardRef } from 'react';

// Styles
import * as style from './style';

interface TextFrameProps {
  content: string;
  className?: string;
}

const TextFrame: FunctionComponent<TextFrameProps> = forwardRef(
  ({ content, className }, ref: any) => (
    <div
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: content }}
      className={className}
      sx={style.TextContainer}
      ref={ref}
    />
  ),
);

export default TextFrame;
